import React from 'react'
import PropTypes from 'prop-types'
import { useValue } from '@morningtrain/react-resources'
import { observer } from 'mobx-react'
import moment from 'moment'

function Date (props) {
  const { name, defaultValue } = props

  let value = useValue(name, defaultValue)

  if (!value) {
    return null
  }

  if (props.forceUTC === true) {
    value = moment.utc(value, props.parseFormat)
  } else {
    value = moment(value, props.parseFormat)
  }

  if (!value) {
    return null
  }

  return value.format(props.dateFormat)
}

Date.defaultProps = {
  defaultValue: null,
  dateFormat: 'DD.MM.YYYY',
  parseFormat: 'YYYY-MM-DD HH:mm:ss ZZ',
  forceUTC: false
}

Date.propTypes = {
  name: PropTypes.string.isRequired,
  defaultValue: PropTypes.any,
  dateFormat: PropTypes.string,
  parseFormat: PropTypes.string,
  forceUTC: PropTypes.bool
}

export default observer(Date)
